<template>
  <div class="tw-flex tw-flex-wrap tw-items-center mx-body tw-py-5 sm:tw-border-none tw-border-b tw-border-gray-800">
    <div class="tw-flex-shrink-0 tw-flex tw-items-center tw-mb-4">
      <EmentoredAppLogo
        height="40"
        width="40"
        icon
        class="tw-flex-shrink-0 transform-scale-0"
        bgColor="var(--maroon)"
      />
      <div style="height: 40px; width: 1px; transform: rotate(14deg)" class="tw-mx-4 tw-bg-gray-800"></div>
      <div>
        <img
          :src="appLogoUrl"
          :key="appLogoUrl"
          alt="eMentored"
          width="auto"
          class="tw-h-12 tw-w-auto tw-max-w-3xl tw-object-contain tw-block tw-flex-shrink-0 transform-scale-0"
        >
      </div>
    </div>

    <div class="tw-flex-grow"></div>

    <div class="tw-flex tw-justify-center tw-flex-grow">
      <div class="tw-flex-grow"></div>

      <BaseButton text="Home" to="/" class="tw-border-none tw-py-3 tw-px-5 tw-mr-3 sm:tw-mr-6" />
      <BaseButton text="Login" to="/login" class="tw-py-3 tw-px-5" />
    </div>
  </div>
</template>

<script>
import EmentoredAppLogo from '@/components/EmentoredAppLogo.vue';

export default {
  name: 'SignUpHeader',
  components: {
    EmentoredAppLogo,
  },
};
</script>

<style>

</style>
